import { addNegatives, xScale } from './create-scale';

const scale = xScale(4)(130);

const BASE = {
  colors: {
    success: ['#26a65b', '#e0f2e8'],
    warning: ['#e5af0a', '#faf0cf'],
    error: ['#d91e18', '#ffeeef'],
    grays: [
      '#252b36',
      '#3a4354',
      '#596781',
      '#7f8da7',
      '#9da8bc',
      '#d9dde5',
      '#e8ebef',
      '#f7f8fa',
    ],
    indigos: [
      '#262d5e',
      '#323a7b',
      '#454ea4',
      '#5762d5',
      '#858ede',
      '#a6ade7',
      '#d8dbf4',
      '#ecedfa',
    ],
    black: '#1b1f27',
    white: '#ffffff',
    TEDRed: '#e62b1e',
  },
  space: addNegatives(scale),
  breakpoints: [
    '400px',
    '576px',
    '768px',
    '992px',
    '1024px',
    '1200px',
    '1600px',
  ],
  fontWeights: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900],
  fonts: [
    'Inter, "Helvetica Neue", Arial, sans-serif',
    'Georgia, serif',
    'Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace',
  ],
  fontSizes: {
    '-2': '13px',
    '-1': '14px',
    '0': '0px',
    '1': '16px',
    '2': '20px',
    '3': '24px',
    '4': '30px',
    '5': '36px',
    '6': '48px',
  },
  lineHeights: [0, '1', '1.5'],
  shadows: [
    '0 0 0 0 transparent',
    '0 1px 5px rgba(0, 0, 0, .5)',
    '0 0 15px 0 rgba(0,0,0,.25)',
    '0 0 25px 0 rgba(0,0,0,.1)',
    '-4px 4px 0px rgba(0, 0, 0, 0.1)',
  ],
  letterSpacings: ['-0.05em', '-0.025em', '0.015em'],
  radii: [0, '2px'],
  zIndices: [-2, -1, 0, 1, 2, 3, 4],
};

// Set up some named properties
/* eslint-disable prefer-destructuring */
const tokens = BASE;

tokens.fonts.sans = BASE.fonts[0];
tokens.fonts.serif = BASE.fonts[1];
tokens.fonts.mono = BASE.fonts[2];
tokens.fontSizes.root = BASE.fontSizes['1'];
tokens.radii.round = '50%';

tokens.space.release = 'calc(-50vw + 50%)';
tokens.space.root = BASE.space[3];
tokens.lineHeights.root = BASE.lineHeights[3];
tokens.sizes = tokens.space;

tokens.colors.indigo = BASE.colors.indigos[3];
tokens.colors.gray = BASE.colors.grays[3];

tokens.shadows.darken = BASE.shadows[0];
tokens.shadows.shallow = BASE.shadows[1];
tokens.shadows.med = BASE.shadows[2];
tokens.shadows.solid = BASE.shadows[3];
tokens.shadows.ghost = 'inset 0 0 0 1px currentColor';

tokens.mediaQueries = {
  xs: `@media screen and (min-width: ${BASE.breakpoints[0]})`,
  sm: `@media screen and (min-width: ${BASE.breakpoints[1]})`,
  md: `@media screen and (min-width: ${BASE.breakpoints[2]})`,
  lg: `@media screen and (min-width: ${BASE.breakpoints[3]})`,
  lgr: `@media screen and (min-width: ${BASE.breakpoints[4]})`,
  xl: `@media screen and (min-width: ${BASE.breakpoints[5]})`,
  xxl: `@media screen and (min-width: ${BASE.breakpoints[6]})`,
};
/* eslint-enable prefer-destructuring */

tokens.styles = {
  root: {
    fontFamily: 'sans',
    fontSize: 'root',
    color: 'black',
    backgroundColor: 'white',
    lineHeight: '16px',
    WebkitFontSmoothing: 'subpixel-antialiased',
  },
};

export default tokens;
